<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Epigraph-rw" epub:type="bodymatter epigraph" id="Epigraph1">
<div class="epigraph-rw" id="epigraph1">
<p class="ep1-rw" id="p33">Hush-a-by, don’t you cry, go to sleep, you little baby.</p>
<p class="ep-rw" id="p34">When you wake you shall have all the pretty little horses</p>
<p class="ep-rw" id="p35">Dapples and grays, pintos and bays,</p>
<p class="ep-rw" id="p36">All the pretty little horses.</p>
</div>
<div class="leading-line-rw" id="leading-line1">
<p id="p37">  </p>
</div>
<div class="epigraph-rw" id="epigraph2">
<p class="ep1-rw" id="p38">Hush-a-by, don’t you cry, go to sleep, you little baby.</p>
<p class="ep-rw" id="p39">When you wake you shall have all the pretty little horses.</p>
<p class="source-rw" id="source1">—traditional pre-Rising lullaby</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s005-Epigraph-001.vue?8f376a06